import React from "react";

// dependencies
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// styles
import css from "./Style.module.scss";

type SledProps = {
	style?: any;
	children: React.ReactNode;
	onChangePosition: (direction: string) => void;
	isAtMaxPosition: boolean;
	position: number;
};
const Sled = ({ style = {}, children, onChangePosition, isAtMaxPosition, position }: SledProps) => {
	const handleBackClick = () => {
		onChangePosition("backward");
	};

	const handleForwardClick = () => {
		onChangePosition("forward");
	};

	const offset = 0;
	const xPosition = position + offset;

	return (
		<div className={css.SledContainer}>
			<div
				className={css.SledWrapper}
				style={{
					...style,
					transform: `translateX(${xPosition}px) translateZ(0px)`,
				}}
			>
				{children}
			</div>

			<div className={`${css.scrollButton} ${css.leftButton} ${position === 0 ? css.hideButton : ""}`}>
				<div onClick={handleBackClick} className={`${css.iconButton}`}>
					<div className={css.iconWrapper}>
						<FontAwesomeIcon icon={["far", "arrow-alt-left"]} />
					</div>
				</div>
			</div>

			<div className={`${css.scrollButton} ${css.rightButton} ${isAtMaxPosition ? css.hideButton : ""}`}>
				<div onClick={handleForwardClick} className={css.iconButton}>
					<div className={css.iconWrapper}>
						<FontAwesomeIcon icon={["far", "arrow-alt-right"]} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Sled;
